import info from "../../../../../assets/icons/info_gold.svg";
import info_bermuda from "../../../../../assets/icons/info_bermuda.svg";
import { USDC } from "../../../../../models/UsdcValue";
import Button from "../../../../miscellaneous/Button";
import { CURRENCY } from "../../../../../utils/Constants";
import { ButtonTheme } from "../../../../miscellaneous/ButtonTheme";
import { useSpring, animated, easings } from "react-spring";
import { mumboJumbo } from "../../../../../utils/Utils";
import { useInView } from "react-intersection-observer";

export interface WithdrawProps {
  value?: USDC;
  onWithdraw: () => void;
  withdrawing: boolean;
  address?: string;
  text: string;
  tooltipText: string;
  theme: ButtonTheme;
}

export default function Withdraw(props: WithdrawProps) {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });
  const prizeAnimation = useSpring({
    from: { number: 0 },
    to: {
      number:
        inView && props.value != undefined ? Number(props.value?.value) : 0,
    },
    config: {
      duration: 2000,
      easing: easings.easeOutQuad,
    },
    reset: !inView,
  });
  return (
    <div
      ref={ref}
      className="flex flex-col lg:items-start items-center"
      data-aos="fade-right"
    >
      <div className="flex flex-row items-center ~mb-0.5/1">
        <span
          className={`font-barlowc font-bold ~text-base/lg bg-gradient-to-b ${props.theme == ButtonTheme.Bermuda ? "from-bermuda to-ming" : "from-mango to-crail"} bg-clip-text text-transparent`}
        >
          {props.text}
        </span>
        <img
          src={props.theme == ButtonTheme.Bermuda ? info_bermuda : info}
          className="select-none ~pl-1/1.5 ~h-3.5/4.5 text-ming"
          alt="info"
          data-tooltip-id="default-tooltip"
          data-tooltip-content={props.tooltipText}
        />
      </div>
      <div className="flex flex-row ~mb-1.5/3 hover:scale-105 duration-250">
        {props.value != undefined ? (
          <animated.div className="font-archb font-bold ~text-xxl/xxxxl ~leading-7/10 bg-clip-text text-transparent bg-gradient-to-br from-white to-emperor">
            {prizeAnimation.number.to((n) =>
              mumboJumbo(n, props.value?.pretty.length ?? 0),
            )}
          </animated.div>
        ) : (
          <div className="font-archb font-bold ~text-xxl/xxxxl ~leading-7/10 bg-clip-text text-transparent bg-gradient-to-br from-white to-emperor">
            0
          </div>
        )}

        <p
          className={`font-archb font-bold ~text-xxl/xxxxl ~leading-7/10 bg-clip-text text-transparent bg-gradient-to-b ${props.theme == ButtonTheme.Bermuda ? "from-bermuda to-ming" : "from-mango to-crail"}`}
        >
          &nbsp;{CURRENCY}
        </p>
      </div>
      <div className="self-center lg:self-start">
        <Button
          theme={props.theme}
          loading={props.withdrawing}
          text={"WITHDRAW"}
          enabled={props.value?.value != undefined && props.value.value > 0}
          onClick={
            props.value?.value != undefined && props.value.value > 0
              ? props.onWithdraw
              : () => {}
          }
        ></Button>
      </div>
    </div>
  );
}
